
import { watch, ref } from 'vue'
import { isString } from '../utils/is';
export const useTitle = (newTitle?: string) => {
    const title = ref<string>(newTitle || '旺盈合同管理系统')

    const watchAction = (n: any, o: any) => {
        document.title = isString(n) && n !== o && document ? document.title : "旺盈合同管理系统"
    }

    watch(() => title, watchAction, { immediate: true })
}